<template>
  <tr>
    <td><card-logo :cardBrand="lineItem.cardBrand"/></td>
    <td>{{lineItem.description}}</td>
    <td><input v-model="lineItem.volume" @blur="updateLine()"/></td>
    <td><input v-model="lineItem.transactionCount" @blur="updateLine()"/></td>
    <td>
      <input v-model="lineItem.actualPercentage" @blur="updateLine()"/>
      <div class="text-right" v-if="hasPublishedPercentage"><span class="badge badge-warning">Published Rate: {{lineItem.expectedPercentage}}</span></div>
    </td>
    <td>
      <input v-model="lineItem.actualPerTransaction" @blur="updateLine()"/>
        <div class="text-right" v-if="hasPublishedTransactionFee"><span class="badge badge-warning">Published Rate: {{lineItem.expectedPerTransaction}}</span></div>
    </td>
    <td class="text-right">
      <input v-bind:value="expectedTotalCaption" readonly/>
      <div class="text-right" v-if="hasTotalMarkup"><span class="badge badge-danger">Markup: {{lineItem.markupAmount}} ({{lineItem.totalMarkup}}%)</span></div>
    </td>
    <td>
      <input v-model="lineItem.actualTotal" @blur="updateLine()"/>
      <div class="text-right" v-if="hasExtraPadding">
        <span class="badge badge-success" v-if="isExtraPaddingNegative">Rounding Error: {{lineItem.extraPadding}}</span>
        <span class="badge badge-danger" v-if="!isExtraPaddingNegative">Extra Padding: {{lineItem.extraPadding}}</span>
      </div>
    </td>
    <td>
      <img v-if="isExtraPaddingNegative" @click="startDelete()" class="bankError float-left" src="/images/bank-error.png"/>
      <button  v-if="!isExtraPaddingNegative" @click="startDelete()" type="button" class="btn btn-sm btn-danger"><i class="fas fa-trash-alt"></i></button>
    </td>
  </tr>
</template>


<script>
import SmallCurrencyInput from '@/components/SmallCurrencyInput'
import PercentInput from '@/components/SmallPercentInput'
import CardLogo from '@blockchyp/crud-magic/src/widgets/CardLogo'

export default {
  name: 'edit-statement-line-item',
  props: ['id', 'categories', 'lineItem'],
  components: {
    'small-currency-input': SmallCurrencyInput,
    'percent-input': PercentInput,
    'card-logo': CardLogo
  },
  data: () => ({
    selectedCategory: null
  }),
  computed: {
    hasExpectedTotal: function () {
      if (this.lineItem.expectedTotal) {
        return true
      }
      return false
    },
    expectedTotalCaption: function () {

      if (this.lineItem.expectedTotal) {
        return this.lineItem.expectedTotal
      } else {
        return "N/A"
      }
    },
    hasExtraPadding: function () {
      if (this.lineItem.extraPadding) {
        return true
      }
      return false
    },
    isExtraPaddingNegative: function () {
      if ( (this.lineItem.extraPadding) && this.lineItem.extraPadding.startsWith('-')) {
        return true
      }
      return false
    },
    hasTotalMarkup: function () {
      if (this.lineItem.totalMarkup) {
        return true
      }
      return false
    },
    hasPublishedPercentage: function () {
      if (this.lineItem.expectedPercentage) {
        return true
      }
      return false
    },
    hasPublishedTransactionFee: function () {
      if (this.lineItem.expectedPerTransaction) {
        return true
      }
      return false
    },
    volumeEnabled: function () {
      if (!this.selectedCategory) {
        return true
      }
      return this.selectedCategory.volumeEnabled
    },
    countEnabled: function () {
      if (!this.selectedCategory) {
        return true
      }
      return this.selectedCategory.countEnabled
    }
  },
  methods: {
    startDelete: function() {
      this.$emit("deleteLineItem", this.lineItem)
    },
    updateLine: function () {
      this.$emit("updateLineItem", this.lineItem)
    },
    submitLine: function () {
      this.$emit("addLineItem", this.lineItem)
    },
    recalcTotal: function() {

    },
    updateCategory: function (catId) {
      for (var i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id === catId) {
          this.selectCategory(this.categories[i])
          return
        }
      }
      this.selectCategory(null)
    },
    selectCategory: function (cat) {
      this.selectedCategory = cat
      this.lineItem.description = cat.name
      this.lineItem.actualPerTransaction = cat.defaultTransactionFee
      this.lineItem.actualTransactionPercentage = cat.defaultTransactionPercentage
      if ( (cat.categoryType === 'interchange') || (cat.categoryType === 'assessments') ) {
        this.lineItem.lineItemType = cat.categoryType
      } else {
        this.lineItem.lineItemType = 'other'
      }

    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

input {
  border: 0;
  width: 100%;
  color: #5b636a;
  text-align: right;
}

.bankError {
  max-height: 40px;
}

.numeric {
  text-align: right;
}

</style>
